import { render, staticRenderFns } from "./albums.vue?vue&type=template&id=c1dd04a2&scoped=true"
import script from "./albums.vue?vue&type=script&lang=js"
export * from "./albums.vue?vue&type=script&lang=js"
import style0 from "./albums.vue?vue&type=style&index=0&id=c1dd04a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dd04a2",
  null
  
)

export default component.exports